"use client";

import React from "react";
import { ShieldCheck, Zap, Clock, BadgeDollarSign } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function WhySellersChooseDhtproperties() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="why-sellers-choose-dhtproperties" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div ref={headerReveal.ref} className={`max-w-3xl mb-16 transition-all duration-1000 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-6">Why Sellers Choose <font color="#eb1414" data-ast-id="f:/src/pages/Home/sections/WhySellersChooseDhtproperties.tsx|sig:33ag9b" data-ast-start="909" data-ast-end="964">New Chapter Property Solutions</font></h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            We provide a transparent, fair, and incredibly fast process. Skip the traditional hassles and sell your home on your terms.
          </p>
        </div>

        {}
        <div ref={gridReveal.ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 auto-rows-[320px] lg:auto-rows-[280px] transition-all duration-1000 delay-200 ease-out ${gridReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <Card className="md:col-span-2 lg:col-span-2 lg:row-span-2 relative overflow-hidden group border-border hover:border-primary transition-colors duration-500 p-0 rounded-2xl">
            <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/no_commissions_handshake.png')] bg-cover bg-center transition-transform duration-1000 ease-out group-hover:scale-105 group-hover:-translate-y-2" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10 transition-opacity duration-500 group-hover:opacity-90" />
            <CardContent className="absolute inset-0 flex flex-col justify-end p-8 md:p-10 z-10">
              <div className="bg-primary/20 w-14 h-14 rounded-full flex items-center justify-center mb-6 backdrop-blur-sm border border-primary/30">
                <BadgeDollarSign className="w-7 h-7 text-primary" />
              </div>
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
                No Realtor Commissions
              </h3>
              <p className="text-white/80 text-lg max-w-md leading-relaxed">
                Keep more of your money. We cover all closing costs and never charge hidden fees. What we offer is what you get.
              </p>
            </CardContent>
          </Card>

          {}
          <Card className="md:col-span-2 lg:col-span-2 lg:row-span-1 relative overflow-hidden group border-border hover:border-primary transition-colors duration-500 p-0 rounded-2xl">
            <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/house_as_is_condition.png')] bg-cover bg-center transition-transform duration-1000 ease-out group-hover:scale-105 group-hover:translate-x-2" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-transparent transition-opacity duration-500 group-hover:opacity-90" />
            <CardContent className="absolute inset-0 flex flex-col justify-center p-8 md:p-10 z-10 w-full md:w-3/4">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3 tracking-tight">
                Sell in Any Condition
              </h3>
              <p className="text-white/80 text-base md:text-lg leading-relaxed">
                No repairs or cleaning required. Don't spend another dime fixing up your property. We buy it exactly as it is today.
              </p>
            </CardContent>
          </Card>

          {}
          <Card className="md:col-span-1 lg:col-span-1 lg:row-span-1 bg-card border-border hover:border-primary transition-colors duration-500 rounded-2xl group flex flex-col justify-between p-8">
            <div className="bg-background w-12 h-12 rounded-xl flex items-center justify-center shadow-sm border border-border group-hover:border-primary/50 transition-colors">
              <Zap className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-card-foreground mb-2 tracking-tight">
                Fast Cash Offers
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                Close in as little as 7–14 days. Get your money quickly and move on with your life.
              </p>
            </div>
          </Card>

          {}
          <Card className="md:col-span-1 lg:col-span-1 lg:row-span-1 bg-card border-border hover:border-primary transition-colors duration-500 rounded-2xl group flex flex-col justify-between p-8">
            <div className="bg-background w-12 h-12 rounded-xl flex items-center justify-center shadow-sm border border-border group-hover:border-primary/50 transition-colors">
              <ShieldCheck className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-card-foreground mb-2 tracking-tight">
                Local Experts
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                Local experienced investors dedicated to a transparent and fair process for every seller.
              </p>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}